<template>
  <div class="list">
    <el-col class="marginBtm">
      <el-card class="searchCard" shadow="never">
        <el-form :inline="true" :model="search_form">
          <el-form-item label="上报时间">
            <date-range-picker
              :value="comeTime"
              @getChange="dateChange"
              type="daterange"
              clearable
              disabledBeforeDate='-1'>
            </date-range-picker>
          </el-form-item>
          <el-form-item label="上报状态">
            <el-select v-model="search_form.reportStatus" style="width:150px;" clearable placeholder="请选择">
              <el-option v-for="item in reportStatusList" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="升级状态">
            <el-select v-model="search_form.upgradeStatus" style="width:150px;" clearable placeholder="请选择">
              <el-option v-for="item in updtStatusList" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="商户编号">
            <el-input style="width:160px;" v-model="search_form.merchantId" auto-complete="off" clearable/>
          </el-form-item>
          <el-form-item label="支付宝商户号">
            <el-input style="width:160px;" v-model="search_form.subMchId" auto-complete="off" clearable/>
          </el-form-item>
          <el-form-item label="SourcePID">
            <el-input style="width:160px;" v-model="search_form.sourcePid" auto-complete="off" clearable/>
          </el-form-item>
          <el-form-item label="商户等级">
            <el-select v-model="search_form.subMchLevel" style="width:150px;" clearable placeholder="请选择">
              <el-option v-for="item in merchantLevelList" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <auth-button opt="search" :plain="true" icon="el-icon-search" @click.native="search" label="查询"></auth-button>
            <auth-button
              opt="export"
              :plain="true"
              icon="el-icon-download"
              @click.native="exportFile"
              :loading="exportLoading"
              label="导出"></auth-button>
          </el-form-item>
        </el-form>
      </el-card>
    </el-col>
    <el-card class="tableCard" shadow="never">
      <el-table stripe style="width: 100%;" v-loading="loading" :data="list" :header-cell-style="{background:'#FAFAFA'}">
        <el-table-column
          prop="fcreateTime"
          label="上报时间"
          width="180"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fmerchantId"
          label="商户编号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="merchantName"
          label="商户全称"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fzfbSubMchId"
          label="支付宝商户号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fsourcePid"
          label="SourcePID"
          align="center">
        </el-table-column>
        <!-- <el-table-column
          prop="pidName"
          label="PID主体"
          align="center">
        </el-table-column> -->
        <el-table-column
          prop="fzfbSubMchLevel"
          label="商户等级"
          align="center">
        </el-table-column>
        <el-table-column
          prop="statusStr"
          label="上报状态"
          align="center">
        </el-table-column>
        <el-table-column
          prop="upgradeStatusStr"
          label="升级状态"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fzfbMsg"
          label="备注"
          align="center">
        </el-table-column>
      </el-table>
    </el-card>
    <el-col :span="24" class="btm-action">
      <el-pagination
        v-if="paginations.total>0"
        class="pagination"
        :page-sizes="paginations.pageSizes"
        :page-size="paginations.pageSize"
        :layout="paginations.layout"
        :total="paginations.total"
        :pageNum="paginations.pageNum"
        @current-change="onChangeCurrentPage">
      </el-pagination>
    </el-col>
  </div>
</template>

<script>
import qs from 'qs'
import { exportAlipayMechant, queryAlipayMechant } from '@/api/channel'
import dateRangePicker from '@/components/dateRangePicker'
const reportStatusList = [{ value: 0, label: '待上报' }, { value: 1, label: '上报成功' },
  { value: 3, label: '上报失败' }, { value: 5, label: '人工禁用' }]

const updtStatusList = [{ value: 0, label: '待升级' }, { value: 1, label: '升级中' },
  { value: 2, label: '升级失败' }, { value: 3, label: '升级成功' }]

const merchantLevelList = [{ value: 'M1', label: 'M1' }, { value: 'M2', label: 'M2' },
  { value: 'M3', label: 'M3' }, { value: 'M4', label: 'M4' }]

export default {
  name: 'AlipayMerchant',
  components: {
    dateRangePicker
  },
  data () {
    return {
      comeTime: [], // 上报时间
      reportStatusList, // 上报状态
      updtStatusList, // 升级状态
      merchantLevelList, // 商户等级
      search_form: {
        startReportTime: '', // 开始time
        endReportTime: '', // 结束time
        reportStatus: '', // 上报状态
        upgradeStatus: '', // 升级状态
        merchantId: '', // 商户编号
        subMchId: '', // 支付宝商户号
        sourcePid: '', // SourcePID
        subMchLevel: '', // 商户等级
        pageNo: 1,
        pageSize: 10,
        count: 0
      },
      export_form: {
        moduleCode: 5,
        moduleName: '上报查询',
        menuName: '支付宝商户'
      },
      loading: false,
      exportLoading: false,
      list: [],
      paginations: {
        pageNum: 1,
        total: 0,
        pageSize: 10,
        pageSizes: [10],
        layout: 'total, prev, pager, next, jumper'
      }
    }
  },
  mounted () {
    this.setDefaultDate()
    this.getList()
  },
  methods: {
    /**
         * @description 初始日期选择
         */
    setDefaultDate () {
      let end = new Date()
      let start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
      start = start.getFullYear() + '-' + (((start.getMonth() + 1) < 10) ? ('0' + (start.getMonth() + 1)) : (start.getMonth() + 1)) + '-' + ((start.getDate() < 10) ? ('0' + start.getDate()) : (start.getDate())) + ' 00:00:00'
      end = end.getFullYear() + '-' + (((end.getMonth() + 1) < 10) ? ('0' + (end.getMonth() + 1)) : (end.getMonth() + 1)) + '-' + ((end.getDate() < 10) ? ('0' + end.getDate()) : (end.getDate())) + ' 23:59:59'
      this.comeTime = [start, end]
      this.dateChange(this.comeTime)
    },
    /**
         * @description 日期选择器change事件
         */
    dateChange (value) {
      if (value !== null && value.length === 2) {
        this.search_form.startReportTime = value[0] && value[0].length === 10 ? value[0] + ' 00:00:00' : value[0]
        this.search_form.endReportTime = value[1] && value[1].length === 10 ? value[1] + ' 23:59:59' : value[1]
        this.comeTime = [this.search_form.startReportTime, this.search_form.endReportTime]
      } else {
        this.search_form.startReportTime = ''
        this.search_form.endReportTime = ''
        this.comeTime = ['', '']
      }
    },
    /**
         * @description 查询列表
         */
    search () {
      // 当点击查询时，显示第一页
      this.search_form.pageNo = 1
      // 让页码数回归到1
      this.paginations.total = 0
      this.getList()
    },
    /**
         * @description 导出文件
         */
    exportFile () {
      // eslint-disable-next-line no-unused-expressions
      this.paginations.total > 0
        ? ((this.comeTime && this.comeTime.length === 2)
          ? (this.exportLoading = true, this.exportList())
          : this.$message({ showClose: true, message: '请先选择导出日期', type: 'info' }))
        : this.$message({ showClose: true, message: '暂无数据可以导出', type: 'info' })
    },
    exportList () {
      [this.search_form.startReportTime, this.search_form.endReportTime] = this.comeTime
      const data = qs.stringify(Object.assign({}, this.formatSearch(this.search_form), this.export_form))
      exportAlipayMechant(data).then(res => {
        if (parseInt(res.result_cde) === 0) {
          this.exportLoading = false
          this.$message({
            message: '导出成功，请大约1min后在下载中心中查看并下载',
            type: 'success'
          })
        } else {
          this.exportLoading = false
          this.$message({
            message: res.result_msg,
            type: 'error'
          })
        }
      })
    },
    /**
         * @description 获取列表数据
         */
    getList () {
      this.loading = true
      let data = this.formatSearch(this.search_form)
      data = qs.stringify(data)
      queryAlipayMechant(data).then((data) => {
        if (parseInt(data.result_cde) !== 0) {
          this.$message({
            showClose: true,
            message: data.result_msg || data.error_msg,
            type: 'error'
          })
          this.loading = false
          this.list = []
        } else {
          this.loading = false
          this.paginations.total = data.totalCount
          this.list = data.list
          this.search_form.count = data.totalCount
        }
      })
    },
    /**
         * @description 改变当前页事件
         * @param  {number} page 当前页码
         */
    onChangeCurrentPage (page) {
      const totalCount = this.search_form.count
      this.search_form.pageNo = page
      this.search_form.Count = totalCount
      this.getList()
    },
    /**
         * @description 清除对象中无值属性
         */
    formatSearch (search) {
      var data = Object.assign({}, search)
      for (var s in data) {
        if (!data[s] && data[s] !== 0) {
          delete data[s]
        }
      }
      return data
    }
  }
}
</script>

<style scoped>
    .list{
        padding-left: 16px;
    }
    .pagination{
        margin: 20px 0;
        text-align: center;
    }
</style>
